var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1966,
    cy: 16,
    rx: 16.0784,
    ry: 16,
    fill: "#90CF60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4509 10.4863C24.8415 10.8768 24.8415 11.5099 24.4509 11.9005L13.8443 22.5071C13.6568 22.6946 13.4024 22.8 13.1372 22.8C12.872 22.8 12.6177 22.6946 12.4301 22.5071L8.44524 18.5222C8.05471 18.1317 8.05471 17.4985 8.44524 17.108C8.83576 16.7174 9.46893 16.7174 9.85945 17.108L13.1372 20.3857L23.0367 10.4863C23.4272 10.0957 24.0604 10.0957 24.4509 10.4863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSuccess);
export default __webpack_public_path__ + "static/media/alert_success.a1413787f1118f97f0577d0662d8e4bc.svg";
export { ForwardRef as ReactComponent };